import { useImageConstants } from "@/app/hooks/useImageConstants";
import NoRecordFoundComponent from "@/app/components/ui/NoRecordFound";
import AuditTrailExportCSVFilterComponent from "../AuditTrailExportCSVFilterComponent";

const AuditTrailExportComponent = () => {
  const { NO_PWL_RESULTS } = useImageConstants();

  return (
    <div>
      <AuditTrailExportCSVFilterComponent />
      <NoRecordFoundComponent imageURL={NO_PWL_RESULTS} message="No Audit Trail Data Found" />
    </div>
  );
};

export default AuditTrailExportComponent;
